import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0.001, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", delay = 0.2 }) => (
  <span className={className}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "105%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.1, delay: delay + i * 0.14, ease: [0.16, 1, 0.3, 1] }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </span>
);

export const SectionHead = ({ eyebrow, title, action, testid }) => (
  <div className="mb-10 flex flex-wrap items-end justify-between gap-4" data-testid={testid}>
    <div>
      <p className="eyebrow mb-3">{eyebrow}</p>
      <h2 className="font-serif-d text-3xl font-semibold tracking-tight text-white sm:text-4xl">{title}</h2>
    </div>
    {action}
  </div>
);
